import { createContext, useContext } from 'react';
import { AuctionType } from '../../types';

const AuctionContext = createContext<AuctionType | undefined>(undefined);

export const AuctionProvider = AuctionContext.Provider;
export const useAuctionContext = (): AuctionType | undefined => useContext(AuctionContext);
